import React, { useEffect, useRef, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import Box from '@mui/system/Box'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import ReceiptExpenseForm from '../component/ReceiptExpenseForm'
import MileageExpenseForm from '../component/MileageExpenseForm'
import { putEditExpense } from 'services/api/modules/claim/expense'
import { getAllCategoriesWithBalanceAllocation } from 'services/api/modules/claim/category'
import { Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'

const EditExpenseForm = ({
  reportData,
  expenseData,
  handleClose,
  setEditModalOpen,
  selectedCategory,
  setSelectedCategory,
  previousSelectedCategory,
}) => {
  const { id: reportId } = reportData
  const refForm = useRef('form')
  const [initialSelectedCategory] = useState(selectedCategory)
  // call data from API and filter only active categories
  const handleSetSelectCategory = (event) => {
    setSelectedCategory(JSON.parse(event.target.value))
  }

  // get all category API
  const {
    isLoading: categoryIsLoading,
    error: categoryError,
    data: categoryData,
  } = useQuery('categoryData', async () => {
    const { data } = await getAllCategoriesWithBalanceAllocation()
    return data
  })

  // put update expense API
  const queryClient = useQueryClient()

  const {
    isLoading: expenseLoading,
    error: expenseError,
    mutate: expenseMutate,
  } = useMutation((values) => putEditExpense(reportId, expenseData?.id, values), {
    onSuccess: async () => {
      setEditModalOpen(false)
      await queryClient.invalidateQueries('singleReportData', {
        exact: true,
      })
      await queryClient.invalidateQueries('singleExpenseData', {
        exact: true,
      })
      await queryClient.invalidateQueries('categoryData')
    },
    onError: async (error) => {
      if (error?.status === 422) {
        const { errors } = error.data
        Object.keys(errors).forEach((key) => {
          refForm?.current?.setFieldError(key, errors[key])
        })
      } else if (error?.status === 404) {
        refForm?.current?.setErrors({
          calculatedAmount: error?.data?.message,
        })
      } else {
        console.log(error)
      }
    },
  })

  // check category type and add previous amount
  const checkAmount = () => {
    const currentAllocated = categoryData?.categories?.filter(
      (item) => item.id === selectedCategory.id
    )[0].allocated

    if (previousSelectedCategory.id === selectedCategory.id && currentAllocated !== null) {
      return parseFloat(currentAllocated) + parseFloat(expenseData?.amount)
    } else {
      return currentAllocated
    }
  }

  // filtered category
  const generalCategory = categoryData?.categories?.filter((item) => item.claim_type === 'General')
  const mileageCategory = categoryData?.categories?.filter((item) => item.claim_type === 'Mileage')

  // useEffect(() => {}, [categoryData]);

  return (
    <Box width={1} sx={{ overflowY: 'auto' }} paddingX={1}>
      <AdxDropdown
        label="Category"
        options={selectedCategory}
        onChange={handleSetSelectCategory}
        defaultValue={JSON.stringify(previousSelectedCategory)}
      >
        {generalCategory?.length > 0 && (
          <Typography variant="body2" paddingY={1} paddingX={2} color="light-gray-text.main">
            GENERAL
          </Typography>
        )}
        {generalCategory?.map((item, index) => (
          <AdxMenuItem
            selectedvalue={JSON.stringify(selectedCategory)}
            key={index}
            value={JSON.stringify(item)}
            sx={{ width: 'calc(100% - 32px)', marginLeft: 2 }}
            disabled={item.allocated === 0}
          >
            {item.name}
          </AdxMenuItem>
        ))}
        {mileageCategory?.length > 0 && (
          <Typography variant="body2" paddingY={1} paddingX={2} color="light-gray-text.main">
            MILEAGE
          </Typography>
        )}
        {mileageCategory?.map((item, index) => (
          <AdxMenuItem
            selectedvalue={JSON.stringify(selectedCategory)}
            key={index}
            value={JSON.stringify(item)}
            sx={{ width: 'calc(100% - 32px)', marginLeft: 2 }}
            disabled={item.allocated === 0 && item.id !== initialSelectedCategory.id}
          >
            {item.name}
          </AdxMenuItem>
        ))}
      </AdxDropdown>

      <Box marginTop={2}>
        {selectedCategory?.claim_type === 'Mileage' ? (
          <MileageExpenseForm
            reportData={reportData}
            category={selectedCategory?.id}
            disabled={!selectedCategory ? true : false}
            ref={refForm}
            mileageRate={selectedCategory?.rate}
            categoryAllocation={checkAmount()}
            expenseMutate={expenseMutate}
            expenseData={expenseData}
          />
        ) : (
          <ReceiptExpenseForm
            reportData={reportData}
            category={selectedCategory?.id}
            disabled={!selectedCategory ? true : false}
            ref={refForm}
            categoryAllocation={checkAmount()}
            expenseMutate={expenseMutate}
            expenseData={expenseData}
          />
        )}

        <Box
          width={1}
          display="flex"
          flexDirection={{ xs: 'column-reverse', lg: 'row' }}
          justifyContent="center"
          alignContent="center"
          columnGap={2}
          marginTop={{ xs: 5, lg: 4 }}
          marginBottom={{ xs: 2, lg: 5 }}
        >
          <AdxButton
            variant={'ghost'}
            onClick={handleClose}
            sx={{
              width: { xs: 1, lg: 1 / 5 },
            }}
          >
            Cancel
          </AdxButton>
          <AdxButton
            isLoading={expenseLoading}
            disabled={!selectedCategory || expenseLoading}
            sx={{
              width: { xs: 1, lg: 4 / 5 },
              marginBottom: { xs: 1, lg: 0 },
            }}
            onClick={() => {
              refForm.current.handleSubmit()
            }}
          >
            Save expense
          </AdxButton>
        </Box>
      </Box>
    </Box>
  )
}

export default EditExpenseForm
